import $ from "jquery";

import recaptcha from "./recaptcha";

const popupDownload = () => {
  const files = [];
  let selectedIndex = null;

  document.querySelectorAll(".js-brochure-btn").forEach((item, index) => {
    files.push({
      downloadLink: item.href,
      documentName: item.dataset.title,
      documentType: item.dataset.type,
    });

    item.addEventListener("click", (e) => {
      e.preventDefault();
      showFormHandler();
      selectedIndex = index;
    });

    item.href = "#";
  });

  if (files.length === 0) return;

  const brochurePopup = document.querySelector(".js-download-popup-form");
  const form = document.querySelector(".download-popup-form__content");
  const submitButton = form.querySelector("button");

  const brochurePopupClose = document.querySelector(
    ".js-download-popup-form__close-icon"
  );
  const brochurePopupOverlay = document.querySelector(
    ".js-download-popup-form__overlay"
  );

  if (!brochurePopup) return;

  const { ibis } = window;

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    disableSubmitButton();

    recaptcha().then((token) => {
      submitForm(token)
        .then(() => {
          closeFormHandler();
          dowloadDocument();
        })
        .catch(() => {
          // body
        })
        .then(() => {
          enableSubmitButton();
        });
    });
  });

  brochurePopupClose.addEventListener("click", () => {
    closeFormHandler();
  });

  const showFormHandler = () => {
    brochurePopup.classList.add("show");
    document.documentElement.style.overflowY = "hidden";
  };

  const closeFormHandler = () => {
    brochurePopup.classList.remove("show");
    document.documentElement.style.overflowY = "visible";
    form.reset();
  };

  const dowloadDocument = () => {
    const link = document.createElement("a");
    link.href = files[selectedIndex].downloadLink;
    link.download = "download";
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const disableSubmitButton = () => {
    submitButton.disabled = true;
  };

  const enableSubmitButton = () => {
    submitButton.disabled = false;
  };

  const submitForm = (token) => {
    return $.ajax(ajax_url, {
      type: "POST",
      ajax: true,
      data: {
        "g-recaptcha-response": token,
        name: form.name.value,
        email: form.email.value,
        company_name: form.company.value,
        subscribed: form.newsletter.checked ? 1 : 0,
        file: files[selectedIndex].documentName,
        type: files[selectedIndex].documentType,
        action: "download_form_submit",
      },
    });
  };

  document.body.addEventListener("keyup", (e) => {
    if (e.keyCode == 27) {
      closeFormHandler();
    }
  });

  brochurePopupOverlay.addEventListener("click", () => {
    closeFormHandler();
  });

  brochurePopup.addEventListener("click", (e) => {
    e.stopPropagation();
  });
};

export default popupDownload;
